import { useRef } from "react";
import { getPublicUrl } from "../../helpers/helper_functions.js";
import AnimalsCanHero from "./AnimalsCanHeroSection/AnimalsCanHero.js";
import GoButton from "./GoButton.js";
import InfoSheet from "./InfoSheet/InfoSheet.js";
import MainPageQuotes from "./MainPageQuotes.js";

import { ParallaxProvider } from "react-scroll-parallax";
import Banner from "../../components/Banner.js";

import "./Home.css";

// this value is manually set right now
const revealAfterSeconds = 4;

const Home = () => {
  const banner2Ref = useRef();

  return (
    <ParallaxProvider>
      <div
        style={{
          position: "relative",
          height: "100%",
          width: "100%",
          overflow: "hidden",
        }}
      >
        <Banner
          className="banner1"
          background_image={getPublicUrl("assets/Home/FirstBackground.jpg")}
          mobile_background_image={getPublicUrl(
            "assets/Home/FirstBackground-mobile.jpg"
          )}
          background_image_details={"no-repeat 30% 80%"}
        >
          {/* <video autoPlay loop muted id="myVideo">
            <source src={getPublicUrl("assets/Home/cowplayback.mp4")} />
          </video> */}

          <MainPageQuotes
            text={
              "The love for all living creatures is the most noble attribute of man"
            }
            author={"Charles Darwin"}
          />

          <GoButton
            style={{
              animation: `fade-in 0.8s ${revealAfterSeconds}s forwards cubic-bezier(0.11, 0, 0.5, 0)`,
            }}
            targetRefForScroll={banner2Ref}
          />
        </Banner>

        <AnimalsCanHero ref={banner2Ref} />

        <InfoSheet />

        {/* Add extra space to prevent footer from cutting off content - desktop only */}
        <div className="desktop-only-spacer" style={{ height: "120px" }} />
        <div style={{ height: "50px" }} />
      </div>
      {/* <SeattleBanner
        className="SeattleBanner"
        style={{ position: "relative", top: "-40px" }}
      /> */}

      {/* This layer must start later  */}
      {/* <div style={{ position: "relative", height: "100%", width: "100%" }}> */}
      {/* This should start 100vh down */}
      {/* <Parallax translateY={[-6, -133]}>
          <MovingHedge />
        </Parallax> */}
      {/* </div> */}
    </ParallaxProvider>
  );
};

export default Home;
